module.exports = __webpack_public_path__ + "img/bg.05052280.jpg";